module.exports = __webpack_public_path__ + "dashboard/img/shuffle.d59726cba1cad070ef83f74c9659f32f.svg";